<template>
    <div class="modal fade request-cancellation-failed" id="requestCancellationFailed" tabindex="-1" role="dialog" aria-labelledby="requestCancellationFailedLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
            <div class="modal-body p-4">
                <p>There was an issue submitting your request. Kindly refresh the page and try again.</p>
                <ColoredButton class="mt-3 w-auto" data-dismiss="modal">OK</ColoredButton>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        computed: {
            contactDetails() {
                return this.$store.getters['GET_FOOTER_SETTINGS']; 
            }
        },
        mounted() {
            // this.$store.dispatch('footerSettings');
        }
    }
</script>